import { SupplierTemplateWebService } from '@linktivity/gds-neo';
import config from '../config';

const templateApi = new SupplierTemplateWebService.TemplateApi(config);

export default templateApi;
